import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./DataMigrationPage.scss";
import heroBanner from "../../assets/images/banner-data-migration.png";
import Copyright from "../../components/Copyright/Copyright";

const DataMigrationPage = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="feature-page">
      {/* Hero Section */}
      <section className="feature-hero">
        <div className="container">
          <div className="feature-hero-image">
            <img src={heroBanner} alt="Data Migration" />
          </div>
        </div>
      </section>

      {/* Data Migration Information */}
      <section className="feature-info">
        <div className="container">
          <div className="feature-grid">
            <div className="feature-details">
              <h2>Data migration services</h2>
              <p>
                Seamlessly transition your financial data to CashManager with our comprehensive
                data migration services. Our expert team ensures zero data loss and minimal
                business disruption during your system transition.
              </p>

              <div className="feature-methods">
                <div className="feature-method">
                  <div className="method-content">
                    <h3>Legacy system migration</h3>
                    <p>
                      Migrate from older accounting systems, spreadsheets, or custom databases
                      to CashManager with complete data integrity and validation.
                    </p>
                  </div>
                </div>

                <div className="feature-method">
                  <div className="method-content">
                    <h3>Custom data transformation</h3>
                    <p>
                      Handle complex data structures and custom formats with tailored
                      transformation processes and validation rules.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="feature-features">
              <h2>Key features</h2>
              <div className="features-list">
                <div className="feature-item">
                  <h3>Zero data loss</h3>
                  <p>Comprehensive backup and validation processes ensure no data is lost during migration.</p>
                </div>

                <div className="feature-item">
                  <h3>Minimal downtime</h3>
                  <p>Carefully planned migration schedules to minimize business disruption and maintain operations.</p>
                </div>

                <div className="feature-item">
                  <h3>Data validation & testing</h3>
                  <p>Thorough testing and validation of migrated data to ensure accuracy and completeness.</p>
                </div>

                <div className="feature-item">
                  <h3>Rollback capability</h3>
                  <p>Complete rollback procedures in case any issues arise during the migration process.</p>
                </div>

                <div className="feature-item">
                  <h3>Expert consultation</h3>
                  <p>Dedicated migration specialists to guide you through the entire process.</p>
                </div>

                <div className="feature-item">
                  <h3>Post-migration support</h3>
                  <p>Ongoing support and training to ensure smooth operation after migration completion.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* Migration Process */}
      <section className="implementation-process">
        <div className="container">
          <div className="section-header">
            <h2>Migration process</h2>
            <p>Our proven methodology ensures a smooth and successful data migration</p>
          </div>

          <div className="process-steps five-steps">
            <div className="process-step">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3>Assessment & planning</h3>
                <p>Analyze your current system, data structure, and requirements to create a detailed migration plan.</p>
              </div>
            </div>

            <div className="process-step">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3>Data mapping & transformation</h3>
                <p>Map data fields between systems and create transformation rules for data compatibility.</p>
              </div>
            </div>

            <div className="process-step">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3>Testing & validation</h3>
                <p>Perform comprehensive testing in a controlled environment to validate data accuracy and integrity.</p>
              </div>
            </div>

            <div className="process-step">
              <div className="step-number">4</div>
              <div className="step-content">
                <h3>Migration execution</h3>
                <p>Execute the migration with minimal downtime and continuous monitoring for any issues.</p>
              </div>
            </div>

            <div className="process-step">
              <div className="step-number">5</div>
              <div className="step-content">
                <h3>Verification & support</h3>
                <p>Verify data integrity and provide training and ongoing support for the new system.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to migrate your data?</h2>
            <p>
              Let our experts handle your data migration with zero risk and minimal disruption.
              Contact us today to discuss your migration needs.
            </p>
            <Link to="/onboarding" className="btn btn-secondary btn-large">Get started</Link>
          </div>
        </div>
      </section>

      {/* Copyright Section */}
      <Copyright />
    </div>
  );
};

export default DataMigrationPage;
